module.exports = __webpack_public_path__ + "static/media/foodtray.c88072d6.svg";